export default __webpack_public_path__ + "static/Corprate_WhoWeAre_BoardofDirectors-MB-A-782ecab27cbe856bb28d88b2709db01e.gif";